module.exports = __webpack_public_path__ + "static/media/framelength.97a44321.svg";